import { Flex as WebFlex } from '@aloft/toolkit-sui';
import { Image as PdfImage } from '@react-pdf/renderer';

import { SiteSizeVsCostPerSFChartUnwrapped } from '../../../components/SiteValueCharts/SiteSizeVsCostPerSFChart.tsx';
import { SiteSizeVsSiteValueChartUnwrapped } from '../../../components/SiteValueCharts/SiteSizeVsSiteValueChart.tsx';
import { SiteToValueRatioChartUnwrapped } from '../../../components/SiteValueCharts/SiteToValueRatioChart.tsx';
import { Flex } from '../../../summary/components/Flex.tsx';
import { PDFOnly } from '../../../summary/components/PDFOnly.tsx';
import { WebOnly } from '../../../summary/components/WebOnly.tsx';
import { useTkv2SiteValueChartsParams } from '../../referenceView/utils/useTkv2SiteValueChartsParams.ts';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { PNG_HEIGHT, PNG_WIDTH } from '../utils/constants.ts';

export const AdjustmentBreakdownSiteValueCharts = (
  props: Tkv2PairedCostSummaryInterfaceV2 & {
    siteSizeVsSiteValuePngSource?: string;
    siteSizeVsCostPngSource?: string;
    siteToValueRatioPngSource?: string;
  },
) => {
  const { siteSizeVsSiteValueChartData, siteSizeVsPriceChartData, siteToValueRatioChartData } =
    useTkv2SiteValueChartsParams();

  return (
    <>
      <WebOnly>
        <WebFlex width="100%" flexDirection="column" gap="1rem" margin="1rem">
          <WebFlex width="100%" gap="1rem">
            <WebFlex
              backgroundColor="textOffset"
              width="100%"
              borderColor="surface4"
              borderWidth="1px"
              borderRadius="4px"
              boxShadow={'0px 4px 6px -1px #0000001A'}
              padding="0.5rem"
            >
              <SiteSizeVsSiteValueChartUnwrapped data={siteSizeVsSiteValueChartData} />
            </WebFlex>
            <WebFlex
              backgroundColor="textOffset"
              width="100%"
              borderColor="surface4"
              borderWidth="1px"
              borderRadius="4px"
              boxShadow={'0px 4px 6px -1px #0000001A'}
              padding="0.5rem"
            >
              <SiteSizeVsCostPerSFChartUnwrapped data={siteSizeVsPriceChartData} />
            </WebFlex>
          </WebFlex>
          {siteToValueRatioChartData && (
            <WebFlex
              backgroundColor="textOffset"
              width="100%"
              borderColor="surface4"
              borderWidth="1px"
              borderRadius="4px"
              boxShadow={'0px 4px 6px -1px #0000001A'}
              padding="0.5rem"
            >
              <SiteToValueRatioChartUnwrapped
                data={siteToValueRatioChartData}
                isLoading={props.publicRecords.isLoading}
              />
            </WebFlex>
          )}
        </WebFlex>
      </WebOnly>
      <PDFOnly>
        <Flex break={true}>
          <Flex flexDirection="column" gap="1rem">
            {props.siteSizeVsSiteValuePngSource && (
              <PdfImage
                src={props.siteSizeVsSiteValuePngSource}
                style={{ height: PNG_HEIGHT, width: PNG_WIDTH }}
              />
            )}
            {props.siteSizeVsCostPngSource && (
              <PdfImage
                src={props.siteSizeVsCostPngSource}
                style={{ height: PNG_HEIGHT, width: PNG_WIDTH }}
              />
            )}
            {props.siteToValueRatioPngSource && (
              <PdfImage
                src={props.siteToValueRatioPngSource}
                style={{ height: PNG_HEIGHT, width: PNG_WIDTH }}
              />
            )}
          </Flex>
        </Flex>
      </PDFOnly>
    </>
  );
};
